import axios, { AxiosRequestConfig, AxiosResponse } from "axios"
import { getEnvVariable } from "../environments/env";
export class HttpTemp {
  
  private static axios = axios.create({
    baseURL:getEnvVariable().temp_base_url,
    headers: {
      "Content-Type": "application/json",
    },
  });

  static async get(url: string, config?: AxiosRequestConfig) {
    try {
      const token = localStorage.getItem('PortalAdmin-AccessToken')
      const headers = token ? { authorization: `Bearer ${token}`,ClientId: process.env.REACT_APP_PAYER_ID,  } : {};
      const updatedConfig: AxiosRequestConfig = { ...config, headers };
      const response = await HttpTemp.axios.get(url, updatedConfig);
      return response.data;
    } catch (e) {
      return HttpTemp.handleErrors(e);
    }
  }
  static async put(url: string, body?: object, config?: AxiosRequestConfig) {
    try {
      const token = localStorage.getItem('PortalAdmin-AccessToken');
      
      const headers = token
      ? {
          Authorization: `Bearer ${token}`,
          ClientId: process.env.REACT_APP_PAYER_ID,
          'Content-Type': 'application/json', // Ensure content type is set
        }
      : {};
      const updatedConfig: AxiosRequestConfig = {
        ...config,
        headers: headers
      };
  
      const response = await HttpTemp.axios.put(url, body, updatedConfig);
      return response;
    } catch (e) {
      HttpTemp.handleErrors(e);
      return Promise.reject(e);
    }
  }

  private static handleErrors(error: any) {
    if (error.response) {
      const errorMessage =
        error.response||
        "Something Went Wrong. Please Try Again";
       //alert(errorMessage)
    } else {
     alert("Something went wrong. Please try again.");
    }
  }
}